TwoFactorVerificationController.$inject = [
	"Authentication.TwoFactorVerificationServices",
	"$scope",
	"$stateParams",
	"$state",
	"$http",
	"$auth"
];

function TwoFactorVerificationController(
	TwoFactorVerificationServices,
	$scope,
	stateParams,
	state,
	http,
	auth
) {
	var self = this;

	let id = stateParams.id;

	self.command = {
		captchaId: null,
		verifyCode: ""
	};

	self.getCaptcha = async function () {
		let parameter = {
			type: "captcha",
			id: self.command.captchaId
		};

		await TwoFactorVerificationServices.get(parameter).$promise.then(
			response => {
				self.captchaImage = "data:image/png;base64," + response.content.captchaImage;
				self.command.captchaId = response.content.captchaId;
			},
			errResponse => {
				iziToast.show({
					message: errResponse.data.message,
					theme: "light",
					color: "red"
				});
				console.log("fail createYear");
			}
		);
	};
	self.getCaptcha();

	const managerLogin = function () {
		iziToast.show({
			message: "شما با موفقیت وارد شدید.",
			theme: "light",
			color: "green"
		});
		location.href = managerLoginUrl;
	};

	const customerLogin = function (checkFirstLogin, personType) {

		iziToast.show({
			message: "شما با موفقیت وارد شدید.",
			theme: "light",
			color: "green"
		});
		if (personType == 'LegalPerson') {
			if (checkFirstLogin == true) {
				location.href = legalClientFirstLoginUrl;
			} else {
				location.href = clientNormalLoginUrl;
			}
		} else if (personType == 'IndividualPerson') {
			if (checkFirstLogin == true) {
				location.href = individualClientFirstLoginUrl;
			} else {
				location.href = clientNormalLoginUrl;
			}
		}

	};

	const loginHandler = function (rawResponse) {

		http.defaults.headers.common.Authorization =
			"Bearer " + rawResponse.auth_token;

		let response = rawResponse;

		if (response.userType == "Customer") {

			TwoFactorVerificationServices.getLogo({
				type: "LegalPersons",
				id: "self"
			})
				.$promise.then(
					function (responseData) {
						response.logo = responseData.content;
					},
					errResponse => {
						console.log("error");
					}
				)
				.finally(function (res) {
					auth.signIn(response, false);
					customerLogin(response.first_login, response.personType);
				});
		} else if (response.userType == "FundUser") {
			TwoFactorVerificationServices.getAuthorizationInfo({
				id: rawResponse.id
			})
				.$promise.then(
					function (responseData) {
						response.groupName = responseData.content.firstGroupName;
						response.permissions = responseData.content.permissionsNames;
					},
					errResponse => {
						console.log("error");
					}
				)
				.finally(function (res) {
					auth.signIn(response, false);
					managerLogin();
				});
		} else {
			iziToast.show({
				message: "شما مجوز ورود به سامانه را ندارید",
				theme: "light",
				color: "red"
			});
		}
	};

	const submit = function (command) {
		if (command.verifyCode.length != 6 || !command.captchaCode) {
			return iziToast.show({
				message: 'فرم را تکمیل کنید.',
				theme: 'light',
				color: 'red',
			});
		}
		let parameter = {
			type: "users",
			id: id,
			routeParams: "verify",
			routeParams2: "two-factor-verification"
		};
		TwoFactorVerificationServices.create(parameter, command).$promise.then(
			response => {
				iziToast.show({
					message: "کد ارسالی تایید گردید",
					theme: 'light',
					color: 'green',
				});
				loginHandler(response);
			},
			errResponse => {
				self.getCaptcha();
				iziToast.show({
					message: errResponse.data.message,
					theme: "light",
					color: "red"
				});
				console.log("fail dffffffffff");
			}
		);
	}

	self.login = submit;


	self.resend = async function () {
		let parameter = {
			type: "Accounts",
			id: id,
			routeParams: "two-factor-verification",
			routeParams2: "resend"
		};

		await TwoFactorVerificationServices.create(parameter, { userId: id }).$promise.then(
			response => {
				iziToast.show({
					message: "کد تایید مجددا ارسال شد.",
					theme: 'light',
					color: 'green',
				});
			},
			errResponse => {
				iziToast.show({
					message: errResponse.data.message,
					theme: "light",
					color: "red"
				});
				// console.log("fail dsadasd");
			}
		);
	};


	$scope.otpInput = {
		size: 6,
		type: "text",
		onDone: function (value) {
			self.command.verifyCode = value;
			if (self.command.captchaCode) {
				submit(self.command)
			}
		}
	};

	self.goToDashboard = function () {
		state.go("Authentication.Login");
	}
}

module.exports = ngModule => {
	ngModule.controller(
		"Authentication.TwoFactorVerificationController",
		TwoFactorVerificationController
	);
};
